import styled from 'styled-components';
import query from 'syf-component-library/const/mediaQueries';
import { Inset } from 'syf-component-library/ui/spacing';
import { colors } from '../../../defaultTheme';
export const ScheduleComponent = styled.div `
  display: flex;
  flex-direction: column;

  @media ${query.greaterThanMedium} {
    flex-direction: column;
  }
`;
export const ScheduleComponentHeader = styled(ScheduleComponent) `
  flex: 1;
`;
export const ScheduleComponentContent = styled(ScheduleComponent) `
  flex: 2;
`;
export const ScheduleContainer = styled.div `
  text-align: left;
  display: flex;
  flex: 1;
  flex-direction: column;

  @media ${query.greaterThanMedium} {
    flex-direction: row;
  }
`;
export const AutoPayWrapper = styled(Inset) `
  margin: 20px auto 32px;
  width: 100%;
  border-top: 1px solid ${colors.mediumGrey};
  border-bottom: 1px solid ${colors.mediumGrey};
`;
